import Modal from "react-awesome-modal";
import classes from "./appSpinner.scss";

const AppSpinner = () => {
    return (
        <section>
            <Modal
                visible='true'
                effect="fadeInUp"
                width="auto"
            >
                <div>
                    <div className={'col-sm-12 col-md-12 col-lg-12 col-xs-12 ' + classes.AppLevelLoderContainer}>
                        <span className={classes.spinnerMessage}>Loading Application. Thanks for waiting.</span>
                    </div>
                    <br />
                    <div className={'col-xs-offset-4 col-xs-6 col-lg-offset-4 col-md-offset-5 ' + classes.sceSquareLoder}>
                        <div className={classes.graphicContainer}>
                            <div className={classes.squareContainer1}>
                                <div className={classes.square} />
                            </div>
                            <div className={classes.squareContainer2}>
                                <div className={classes.square} />
                            </div>
                            <div className={classes.squareContainer3}>
                                <div className={classes.square} />
                            </div>
                            <div className={classes.clear} />
                        </div>
                    </div>
                </div>
            </Modal>
        </section>
    );
};

export default AppSpinner;